import React from "react";

function ErrorList(props) {
  if (props.errors != null && props.errors.length > 0) {
    return (
      <div>
        <ul className={props.listClass}>
          {props.errors.map((err, i) => (
            <li className={props.itemClass} key={i}>
              {err}
            </li>
          ))}
        </ul>
      </div>
    );
  } else return null;
}

export default ErrorList;
